export const messages = {
  en: {
    editMaintainancePlan: {
      title: 'Edit Maintenance Plan',
      planName: 'Plan Name',
      planNamePlaceholder: 'Required, please enter plan name',
      standard: 'Maintenance Standard',
      standardPlaceholder: 'Required, please select maintenance standard',
      period: 'Inspection Cycle',
      periodPlaceholder: 'Required, please select inspection cycle',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      fixedDay: 'Fixed Days',
      fixedDayPlaceholder: 'Required, please enter days',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please select start date',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please select end date',
      selectStaff: 'Select Staff',
      saveSuccess: 'Save successfully',
      saveError: 'Save failed',
      fetchStandardError: 'Failed to get maintenance standards',
      fetchPlanError: 'Failed to get maintenance plan',
      fetchStaffError: 'Failed to get staff list'
    },
    orgTree: {
      fetchError: 'Failed to get organization tree'
    }
  },
  zh: {
    editMaintainancePlan: {
      title: '修改保养计划',
      planName: '计划名称',
      planNamePlaceholder: '必填，请填写计划名称',
      standard: '保养标准',
      standardPlaceholder: '必填，请选择保养标准',
      period: '巡检周期',
      periodPlaceholder: '必填，请选择巡检周期',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      fixedDay: '固定天数',
      fixedDayPlaceholder: '必填，请填写多少天后保养一次',
      startDate: '开始日期',
      startDatePlaceholder: '必填，请填写开始日期',
      endDate: '结束日期',
      endDatePlaceholder: '必填，请填写结束日期',
      selectStaff: '选择员工',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      fetchStandardError: '获取保养标准失败',
      fetchPlanError: '获取保养计划失败',
      fetchStaffError: '获取员工列表失败'
    },
    orgTree: {
fetchError: '获取组织树失败'
    }
  },
  'zh-TW': {
    editMaintainancePlan: {
      title: '修改保養計劃',
      planName: '計劃名稱',
      planNamePlaceholder: '必填，請填寫計劃名稱',
      standard: '保養標準',
      standardPlaceholder: '必填，請選擇保養標準',
      period: '巡檢週期',
      periodPlaceholder: '必填，請選擇巡檢週期',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      fixedDay: '固定天數',
      fixedDayPlaceholder: '必填，請填寫多少天後保養一次',
      startDate: '開始日期',
      startDatePlaceholder: '必填，請填寫開始日期',
      endDate: '結束日期',
      endDatePlaceholder: '必填，請填寫結束日期',
      selectStaff: '選擇員工',
      saveSuccess: '保存成功',
      saveError: '保存失敗',
      fetchStandardError: '獲取保養標準失敗',
      fetchPlanError: '獲取保養計劃失敗',
      fetchStaffError: '獲取員工列表失敗'
    },
    orgTree: {
      fetchError: '獲取組織樹失敗'
    }
  }
}